// src/App.js
import React from 'react';

function App() {
    return (
        <div style={styles.app}>
            <div style={styles.policyContainer}>
                <h1>Privacy Policy for Exchange Wise</h1>
                <p>Last Updated: 10/31/2024</p>

                <section>
                    <h2>1. Introduction</h2>
                    <p>
                        Welcome to Exchange Wise! We value your privacy and are committed to protecting it. This Privacy Policy explains our practices and confirms that Exchange Wise does not collect, store, or share any personal information from users.
                    </p>
                </section>

                <section>
                    <h2>2. Information We Collect</h2>
                    <p>
                        Exchange Wise does not collect or request any personal data from users. The app operates fully offline and does not require names, emails, or location data to function.
                    </p>
                    <ul>
                        <li><strong>Settings and Preferences:</strong> Any settings preferences, such as light or dark mode, are stored locally on your device to enhance your experience. This data is not accessible by us or shared with any third parties.</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Use of Personal Information</h2>
                    <p>
                        Since we do not collect or access personal information, there is no data to share, sell, or disclose to third parties.
                    </p>
                </section>

                <section>
                    <h2>4. In-App Purchases</h2>
                    <p>
                        If any in-app purchases are made in the future, transactions will be handled securely through Google Play or the App Store. We do not have access to your payment information or transaction history. Please refer to Google Play or the App Store’s Privacy Policy for details on how they handle your data during purchases.
                    </p>
                </section>

                <section>
                    <h2>5. Data Security</h2>
                    <p>
                        Your app preferences and settings are stored locally on your device. Since we do not collect or transfer this data, it remains secure and private to you.
                    </p>
                </section>

                <section>
                    <h2>6. Children’s Privacy</h2>
                    <p>
                        Exchange Wise is suitable for general audiences. We do not knowingly collect any data from children or users under the age of 13.
                    </p>
                </section>

                <section>
                    <h2>7. Changes to This Privacy Policy</h2>
                    <p>
                        We may update this Privacy Policy periodically. Any changes will be posted on this page, and we encourage you to review it from time to time.
                    </p>
                </section>

                <section>
                    <h2>8. Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy or our data practices, please contact us at: info@itforsec.com
                    </p>
                </section>
            </div>
        </div>
    );
}

const styles = {
    app: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: '1.6',
    },
    policyContainer: {
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    },
    section: {
        marginBottom: '20px',
    },
};

export default App;
